/**
 * Persists GET /client list responses in localStorage (search + limit + user).
 */

import { stableStringify } from './stableStringify';

const STORAGE_KEY = 'vacspl_clients_list_cache';

export function buildClientsListCacheKey(search, limit, userId = '') {
  return stableStringify({
    search: (search || '').trim(),
    limit,
    userId: userId || '',
  });
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.warn('clients list cache: write failed', e);
  }
}

/**
 * Cached shape matches fetchClients success: { success: true, data: Array }
 */
export function getCachedClientsList(cacheKey) {
  const map = readStore();
  const entry = map[cacheKey];
  if (!entry || entry.success !== true || !Array.isArray(entry.data)) return null;
  return entry;
}

export function setCachedClientsList(cacheKey, result) {
  const map = readStore();
  map[cacheKey] = result;
  writeStore(map);
}

export function clearClientsListCache() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
